import getButtonStyle from '../utils/view/getButtonStyle';
import { DefaultButton, IButtonStyles } from 'office-ui-fabric-react/lib/Button';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import * as React from 'react';
import ActionButtonStyle from 'txp-data/lib/schema/viewSchema/ActionButtonStyle';

export interface ActionButtonProps {
    buttonElementText: string;
    style: ActionButtonStyle;
    controlIconName?: string;
    onClickHandler?: () => void;
    anchorLink?: string;
    target?: string;
    showSpinner?: boolean;
}

export default class ActionButton extends React.Component<ActionButtonProps, {}> {
    render() {
        let {
            buttonElementText,
            style,
            onClickHandler,
            anchorLink,
            target,
            controlIconName,
            showSpinner,
        } = this.props;

        let themeColorOverride = style.themeColor ? { color: style.themeColor } : null;
        let buttonStyles: IButtonStyles = getButtonStyle(style);

        return style.darkerColor ? (
            <DefaultButton
                role="button"
                onClick={onClickHandler}
                href={anchorLink ? anchorLink : null}
                target={target ? target : null}
                disabled={showSpinner}
                styles={buttonStyles}>
                {showSpinner ? (
                    <Spinner size={SpinnerSize.small} />
                ) : (
                    <Icon className={style.iconStyle} iconName={controlIconName} />
                )}
                <div className={style.buttonTextStyle}>{buttonElementText}</div>
            </DefaultButton>
        ) : (
            <Link
                role="button"
                onClick={onClickHandler}
                href={anchorLink ? anchorLink : null}
                target={target ? target : null}
                disabled={showSpinner}
                style={themeColorOverride}
                styles={{ root: style.buttonStyle }}>
                {showSpinner ? (
                    <Spinner size={SpinnerSize.small} />
                ) : (
                    <Icon className={style.iconStyle} iconName={controlIconName} />
                )}
                <div className={style.buttonTextStyle}>{buttonElementText}</div>
            </Link>
        );
    }
}
